import { useState } from 'react';
import { Modal } from './Modal'; 
import DialogContent from '@mui/material/DialogContent';
import Sketch from '@uiw/react-color-sketch';
import Box from '@mui/material/Box';
import { P } from 'components';

export default function ColorPickerModal({
    open = false,
    color = '#ffffff',
    onChange = () => {},
    onClose = () => {},
}:{
    open?: boolean;
    color?: string;
    onChange?: (hex: string) => void;
    onClose?: () => void;
}) {

    const [hex, setHex] = useState(color);

    const handleClose = () => {
        onClose();
    }

    return (
        <Modal
            open={open}
            closed={handleClose}
            title="Color Picker"
        >
            <DialogContent>
                <Box mb={3} textAlign='center'>
                    Selected Color:
                    <Box margin={'0 auto'} width={150} height={30} sx={{ backgroundColor: hex, border: '1px solid' }}/>
                </Box>
                <Box margin='0 auto' pr={2}>
                    <Sketch
                        style={{ marginLeft: 20 }}
                        color={hex}
                        disableAlpha={true}
                        onChange={(color) => {
                            setHex(color.hex);
                            onChange(color.hex);
                        }}
                    />
                </Box>
            </DialogContent>
        </Modal>
    )
}